import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"
// import { Button } from "../../reusableComponents/Button"
import wwsLogo from "../../../assets/images/wws-logo.svg"
import { useLocation } from "@reach/router"
import TrustpilotWidget from "../../reusableComponents/TrustPilotWidget"
import styled from "styled-components"

import {
  Nav,
  NavLogo,
  MenuIcon,
  Bars,
  Logo,
  NavMenu,
  BarsTimes,
  // NavBtn,
  NavLink,
  LinkContainer,
  DropDown,
  DropdownContent,
  DropdownLink,
  MenuLink,
  MenuItemLink,
} from "./HeaderElements"
import { gsap } from "gsap"

const Header = ({ siteTitle, onNavStateChange }) => {
  const [clicked, setClicked] = useState(false)
  const location = useLocation()
  const isMovieTrailerPage = location.pathname === "/movie-trailer"

  const openNav = e => {
    e.preventDefault()
    setClicked(prevState => {
      const nextState = !prevState
      onNavStateChange(nextState)
      return nextState
    })
  }

  let container = useRef(null)
  let nav = useRef(null)

  let tl = new gsap.timeline({ delay: 1.2 })

  useEffect(() => {
    let mounted = true

    const logo = container.firstElementChild
    // const button = container.lastElementChild

    const homeNav = nav.children[0]
    const serviceNav = homeNav.nextSibling
    const bookHubNav = serviceNav.nextSibling
    const movieTrailerNav = bookHubNav.nextSibling
    const aboutNav = movieTrailerNav.nextSibling
    const contactNav = aboutNav.nextSibling

    if (mounted) {
      gsap.to(container, { duration: 1, css: { visibility: "visible" } })
      tl.from(
        [
          logo,
          homeNav,
          serviceNav,
          bookHubNav,
          aboutNav,
          movieTrailerNav,
          // bookTrailer,
          // blogNav,
          contactNav,
          // button,
        ],
        { duration: 1, opacity: 0, y: -50, ease: "power3.out", stagger: 0.15 }
      )
    }

    return function cleanup() {
      mounted = false
    }
  }, [])

  return (
    <Nav
      className="headerContainer"
      ref={el => (container = el)}
      $isDark={isMovieTrailerPage}
    >
      <NavLogo to="/" $isDark={isMovieTrailerPage}>
        <Logo src={wwsLogo} />
      </NavLogo>
      <MenuIcon
        onClick={openNav}
        navMenu={clicked}
        $isDark={isMovieTrailerPage}
      >
        {clicked ? (
          <BarsTimes $isDark={isMovieTrailerPage} />
        ) : (
          <Bars $isDark={isMovieTrailerPage} />
        )}
      </MenuIcon>
      <NavMenu
        navMenu={clicked}
        ref={el => (nav = el)}
        $isDark={isMovieTrailerPage}
      >
        <LinkContainer onClick={openNav}>
          <NavLink
            to="/"
            className={
              "headerLink" + (isMovieTrailerPage ? " movie-trailer-link" : "")
            }
            activeClassName="active"
            $isDark={isMovieTrailerPage}
          >
            Home
          </NavLink>
        </LinkContainer>
        {/* <LinkContainer onClick={openNav}>
          <NavLink to="/services" className="headerLink" activeClassName="active">
            Services
          </NavLink>
        </LinkContainer> */}
        <DropDown>
          <LinkContainer>
            <MenuLink
              className={
                location.pathname === "/publishing-services" ||
                location.pathname === "/marketing-services"
                  ? "headerLink active"
                  : "headerLink" +
                    (isMovieTrailerPage ? " movie-trailer-link" : "")
              }
              $isDark={isMovieTrailerPage}
            >
              Services
            </MenuLink>
          </LinkContainer>
          <DropdownContent className="return-to-top">
            <DropdownLink onClick={openNav}>
              <MenuItemLink
                to="/publishing-services"
                className="dropdown-headerLink"
                activeClassName="active"
              >
                Publishing Services
              </MenuItemLink>
            </DropdownLink>
            <DropdownLink onClick={openNav}>
              <MenuItemLink
                to="/marketing-services"
                className="dropdown-headerLink"
                activeClassName="active"
              >
                Marketing Services
              </MenuItemLink>
            </DropdownLink>
          </DropdownContent>
        </DropDown>
        <DropDown>
          <LinkContainer>
            <MenuLink
              className={
                location.pathname === "/book-trailers" ||
                location.pathname === "/book-library"
                  ? "headerLink active"
                  : "headerLink" +
                    (isMovieTrailerPage ? " movie-trailer-link" : "")
              }
              $isDark={isMovieTrailerPage}
            >
              Book Hub
            </MenuLink>
          </LinkContainer>
          <DropdownContent className="return-to-top">
            <DropdownLink onClick={openNav}>
              <MenuItemLink
                to="/book-trailers"
                className="dropdown-headerLink"
                activeClassName="active"
              >
                Book Trailers
              </MenuItemLink>
            </DropdownLink>
            <DropdownLink onClick={openNav}>
              <MenuItemLink
                to="/book-library"
                className="dropdown-headerLink"
                activeClassName="active"
              >
                Book Library
              </MenuItemLink>
            </DropdownLink>
          </DropdownContent>
        </DropDown>
        {/* <LinkContainer onClick={openNav}>
          <NavLink to="/book-trailers" className="headerLink" activeClassName="active">
            Book Trailers
          </NavLink>
          </LinkContainer> */}
        <LinkContainer onClick={openNav}>
          <NavLink
            to="/movie-trailer"
            className={"headerLink"}
            activeClassName="active"
            $isDark={isMovieTrailerPage}
          >
            Movie Trailers
          </NavLink>
        </LinkContainer>

        <LinkContainer onClick={openNav}>
          <NavLink
            to="/about"
            className={
              "headerLink" + (isMovieTrailerPage ? " movie-trailer-link" : "")
            }
            activeClassName="active"
            $isDark={isMovieTrailerPage}
          >
            About Us
          </NavLink>
        </LinkContainer>

        {/* <LinkContainer onClick={openNav}>
          <NavLink to="/vlogs" className="headerLink" activeClassName="active">
            Vlogs
          </NavLink>
        </LinkContainer> */}
        <LinkContainer onClick={openNav}>
          <NavLink
            to="/contact"
            className={
              "headerLink" + (isMovieTrailerPage ? " movie-trailer-link" : "")
            }
            activeClassName="active"
            $isDark={isMovieTrailerPage}
          >
            Contact Us
          </NavLink>
        </LinkContainer>
        <TrustpilotContainer>
          <TrustpilotWidget />
        </TrustpilotContainer>
        {/* <NavLink
          to="/submission"
          className="headerLink"
          activeClassName="active"
          css={`
            display: none;
            @media screen and (max-width: 768px) {
              display: block;
              margin-top: 1.5rem;
            }
          `}
        >
          Submit now
        </NavLink> */}
      </NavMenu>
      {/* <NavBtn>
        <Button to="/submission" round="true">
          Submit now
        </Button>
      </NavBtn> */}
    </Nav>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  onNavStateChange: PropTypes.func,
}

Header.defaultProps = {
  siteTitle: ``,
  onNavStateChange: () => {},
}

export default Header

const TrustpilotContainer = styled.div`
  width: auto;

  @media screen and (max-width: 1124px) {
    display: none;
  }

  @media screen and (max-width: 968px) {
    display: flex;
    margin-top: 1rem;
  }
`
